import { useState } from "react";
import { SupabaseClient } from "../../../supabaseClient";
import {
    Button,
    FormControl,
    FormLabel,
    Input,
    Modal,
    ModalBody,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay
} from "@chakra-ui/react";

const KG_TO_LB = 2.20462;

/** Modal component for logging a new weight */
export function LogWeightModal({
                                   isOpen,
                                   unit = "kg",     // 'kg' or 'lb'
                                   onClose,
                                   profileId,
                                   onSuccess
                               }) {
    const [weight, setWeight] = useState("");
    const [date, setDate]     = useState(new Date().toISOString().split("T")[0]);
    const [isSaving, setIsSaving] = useState(false);

    const handleSave = async () => {
        if (!weight) return;
        setIsSaving(true);

        // convert to kg if user entered lbs
        const parsed = parseFloat(weight);
        const weightKg =
            unit === "lb"
                ? parseFloat((parsed / KG_TO_LB).toFixed(2))
                : parsed;

        const { error } = await SupabaseClient
            .from("weight_entries")
            .insert([{ profile_id: profileId, weight_kg: weightKg, date }]);

        setIsSaving(false);
        if (!error) onSuccess();
        else console.error(error);
    };

    return (
        <Modal isOpen={isOpen} onClose={onClose} isCentered>
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>Log New Weight</ModalHeader>
                <ModalBody>
                    <FormControl mb={4}>
                        <FormLabel>Weight ({unit})</FormLabel>
                        <Input
                            type="number"
                            step="0.1"
                            value={weight}
                            onChange={(e) => setWeight(e.target.value)}
                            placeholder={unit === "kg" ? "e.g. 68.5" : "e.g. 150.9"}
                        />
                    </FormControl>
                    <FormControl>
                        <FormLabel>Date</FormLabel>
                        <Input
                            type="date"
                            value={date}
                            onChange={(e) => setDate(e.target.value)}
                        />
                    </FormControl>
                </ModalBody>
                <ModalFooter>
                    <Button variant="ghost" mr={3} onClick={onClose}>
                        Cancel
                    </Button>
                    <Button
                        colorScheme="blue"
                        isLoading={isSaving}
                        onClick={handleSave}
                    >
                        Save
                    </Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
}